/**
 * Parse time string like "08:00" or "8:00 AM" to minutes since midnight.
 * Shared by appointment-form and custom-date-picker.
 */
export function parseTimeToMinutes(timeString: string): number {
  let time = timeString.trim();

  if (time.includes('AM') || time.includes('PM')) {
    const isPM = time.includes('PM');
    time = time.replace(/[AP]M/i, '').trim();
    const [hours, minutes] = time.split(':').map(Number);
    let hour24 = hours;
    if (isPM && hours !== 12) {
      hour24 = hours + 12;
    } else if (!isPM && hours === 12) {
      hour24 = 0;
    }
    return hour24 * 60 + minutes;
  }

  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

/** Returns a new Date offset by the given number of minutes. */
export function addMinutesToDate(date: Date, minutes: number): Date {
  return new Date(date.getTime() + minutes * 60 * 1000);
}

/** True when `later` is at least `minutes` after `earlier` (inclusive). */
export function isDateAtLeastMinutesAfter(later: Date, earlier: Date, minutes: number): boolean {
  return later.getTime() >= earlier.getTime() + minutes * 60 * 1000;
}

/**
 * True when `laterTime` (HH:mm) is at least `minutes` after `earlierTime` on the
 * same clock day. Overnight ranges are not treated as valid here.
 */
export function isTimeAtLeastMinutesAfter(
  laterTime: string,
  earlierTime: string,
  minutes: number
): boolean {
  return parseTimeToMinutes(laterTime) >= parseTimeToMinutes(earlierTime) + minutes;
}
